import * as Sentry from '@sentry/vue'
import settings from '@/settings'

// Must stay in sync with the `--release` flag in the `sentry:sourcemaps` npm
// script, otherwise uploaded sourcemaps won't match the reported events.
const RELEASE = 'first-local'

const TRACES_SAMPLE_RATE = 0.2
const REPLAYS_SESSION_SAMPLE_RATE = 0.01
const REPLAYS_ON_ERROR_SAMPLE_RATE = 1.0

function apiTracePropagationTarget() {
  try {
    return new URL(settings.API_URL).origin
  } catch {
    return settings.API_URL
  }
}

export function initSentry({ app, router }) {
  if (process.env.NODE_ENV !== 'production') return false
  if (!settings.SENTRY_DSN) return false

  Sentry.init({
    app,
    dsn: settings.SENTRY_DSN,
    environment: settings.SENTRY_ENVIRONMENT,
    release: RELEASE,
    skipBrowserExtensionCheck: true,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: TRACES_SAMPLE_RATE,
    tracePropagationTargets: [apiTracePropagationTarget()],
    replaysSessionSampleRate: REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: REPLAYS_ON_ERROR_SAMPLE_RATE
  })

  return true
}
